export interface TimeCommitmentNode {
  id: string;
  name: string;
  description: string;
  hoursPerWeek: number;
  suitableFor: string[];
  pros: string[];
  cons: string[];
  idealBusinessTypes?: string[];
}

export const TIME_COMMITMENT_TAXONOMY: TimeCommitmentNode[] = [
  {
    id: 'side-hustle',
    name: 'Side Hustle',
    description: 'Pursuing a business alongside a primary job or commitment',
    hoursPerWeek: 10,
    suitableFor: [
      'Full-time employees',
      'Students',
      'Freelancers',
      'Part-time workers'
    ],
    pros: [
      'Minimal financial risk',
      'Steady primary income',
      'Flexibility',
      'Low initial time investment',
      'Opportunity to test business concept'
    ],
    cons: [
      'Slower growth',
      'Limited time for development',
      'Potential burnout',
      'Competing priorities',
      'Slower learning curve'
    ],
    idealBusinessTypes: [
      'Online Consulting',
      'Digital Products',
      'Dropshipping',
      'Freelance Services',
      'Content Creation'
    ]
  },
  {
    id: 'part-time',
    name: 'Part-Time Venture',
    description: 'Dedicating significant time to building a business with some flexibility',
    hoursPerWeek: 20,
    suitableFor: [
      'Entrepreneurs with some savings',
      'Professionals seeking career change',
      'Creative individuals',
      'Skilled practitioners'
    ],
    pros: [
      'More focused development',
      'Balanced lifestyle',
      'Reduced financial pressure',
      'Ability to pivot',
      'Gradual skill building'
    ],
    cons: [
      'Moderate financial investment',
      'Slower scaling',
      'Complex time management',
      'Potential income instability',
      'Longer path to full-time business'
    ],
    idealBusinessTypes: [
      'Local Services',
      'Online Coaching',
      'Specialized Consulting',
      'E-commerce',
      'Niche Product Development'
    ]
  },
  {
    id: 'full-time',
    name: 'Full-Time Entrepreneurship',
    description: 'Completely dedicating yourself to building and growing a business',
    hoursPerWeek: 40,
    suitableFor: [
      'Committed entrepreneurs',
      'Individuals with substantial savings',
      'High-risk tolerant professionals',
      'Innovative thinkers'
    ],
    pros: [
      'Maximum potential for growth',
      'Full focus and dedication',
      'Rapid skill development',
      'Unlimited scaling potential',
      'Complete control'
    ],
    cons: [
      'High financial risk',
      'Significant personal investment',
      'Potential financial instability',
      'High stress levels',
      'Complete dependency on business success'
    ],
    idealBusinessTypes: [
      'Tech Startups',
      'Scalable Service Businesses',
      'Product Companies',
      'Innovative Solutions',
      'Disruptive Technologies'
    ]
  }
];

// Utility function to find time commitment by ID
export function findTimeCommitmentById(id: string): TimeCommitmentNode | undefined {
  return TIME_COMMITMENT_TAXONOMY.find(commitment => commitment.id === id);
}
